<template>
  <router-view />
</template>

<script>
import productModule from '../../store/products'
import supplierModule from '../../store/suppliers'
import categoriesModule from '../../store/categories'

export default {
  beforeCreate () {
    this.$store.registerModule('products', productModule)
    this.$store.registerModule('suppliers', supplierModule)
    this.$store.registerModule('categories', categoriesModule)
  },
  destroyed () {
    this.$store.unregisterModule('products')
    this.$store.unregisterModule('suppliers')
    this.$store.unregisterModule('categories')
  }
}
</script>
